import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {Button} from '@customink/pigment-react';
import {metrics} from '~/vendor/metrics';
import Notification from '~/components/Notification';
import {getNotification} from '~/selectors/NotificationSelectors';
import {ID_VIEW_MAP} from '~/constants/ProductConstants';
import {listify} from '~/utils/text';
import {getViewName} from '~/utils/catalog';

import './PrintMethodWarning.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function UnsupportedDesignAreasWarning(props) {
  const notification = useSelector(getNotification);
  const namedMismatchedAreas =
    notification?.mismatchedAreas?.map(viewIndex => {
      return getViewName(ID_VIEW_MAP[viewIndex], false).toLowerCase();
    }) || [];

  useEffect(() => {
    metrics.pageViewTag('/ndx/printmethod/warning/unsupporteddesignareas');
  }, []);

  const handleChangePrintMethod = () => {
    metrics.fireEvent(
      'unsupported design areas warning',
      'change print method',
      'confirmation'
    );
    notification?.onConfirm?.();
    props.dismiss();
  };

  const handleCancel = () => {
    metrics.fireEvent(
      'unsupported design areas warning',
      'change print method',
      'cancelled'
    );
    props.dismiss();
  };

  return (
    <Notification
      {...props}
      dismiss={handleCancel}
      title="Whoops! This print method does not support one or more of your design areas.">
      <p className="ndx-cta1">
        If you switch to Embroidery, we will need to remove your{' '}
        {listify(namedMismatchedAreas)} design(s).
      </p>
      <Button
        size="large"
        className="ndx-PrintMethodWarning-changeBtn"
        onClick={handleChangePrintMethod}>
        Change Print Method
      </Button>
      <Button
        variant="link"
        className="ndx-PrintMethodWarning-cancelLink"
        onClick={handleCancel}>
        Cancel
      </Button>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func
};

UnsupportedDesignAreasWarning.propTypes = propTypes;

UnsupportedDesignAreasWarning.displayName = 'UnsupportedDesignAreasWarning';
